<template>
  <div>
    <UserSignup></UserSignup>
  </div>
</template>

<script>
import UserSignup from "@/components/user/UserSignup.vue";

export default {
  name: "UserSignupView",
  components: {
    UserSignup
  }
};
</script>

<style lang="scss" scoped></style>
